export default "__VITE_ASSET__fa7af0c2__"